import React, { useRef, useState } from 'react';
import ContentEditable from 'react-contenteditable';
import { Dropdown, Form , Modal} from 'antd';
import PlusIcon from '../../assests/icons/plus.icon';
import CloseIcon from '../../assests/icons/close.icon';
import DownChevronIcon from '../../assests/icons/down-chevron.icon';
import '../Editable/editable.less';
import formatter from 'string-format';

const tagComponent = '<div class="params-element" data-key="{0}" contenteditable="false">{0}' +
'<span class="remove">' +
'<svg ' +
'    xmlns="http://www.w3.org/2000/svg" ' +
'    width="24" ' +
'    height="24" ' +
'    viewBox="0 0 24 24" ' +
'    {...props} ' +
'  > ' +
'    <path ' +
'      d="M17.895 5L17.895 16.106 29 16.105 29 17.895 17.895 17.895 17.895 29 16.105 29 16.106 17.895 5 17.895 5 16.105 16.106 16.106 16.105 5z" ' +
'      transform="translate(-5 -5) rotate(45 17 17)" ' +
'    /> ' +
'  </svg>' +
'</span>' +
'</div>';

const paramConst="%{0}%"


const EditableTextarea = (props) => {
  const [editableContentHtml, setEditableContentHtml] = useState(``);
  const [editableContentValue, setEditableContentValue] = useState(``);
  const [cleanedText, setCleanedText] = useState(``);
  const editableRef = useRef(null);
 
  const onClickContentEditable = (e) => {
    if (e.target.className === 'remove') {
      e.target.parentNode.remove();
    }
  };
  // const arraySSS = [
  //   {
  //     key: 'MSISDN',
  //     label: 'Telefon Numarası',
  //     value:
  //       ,
  //   },
  //   {
  //     key: 'Ad',
  //     label: 'Ad',
  //     value:
  //       '<div class="params-element" data-key="Ad" contenteditable="false">Ad Soyad' +
  //       '<span class="remove">' +
  //       '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}> ' +
  //       '    <path ' +
  //       '      d="M17.895 5L17.895 16.106 29 16.105 29 17.895 17.895 17.895 17.895 29 16.105 29 16.106 17.895 5 17.895 5 16.105 16.106 16.106 16.105 5z" ' +
  //       '      transform="translate(-5 -5) rotate(45 17 17)" ' +
  //       '    /> ' +
  //       '  </svg>' +
  //       '</span>' +
  //       '</div>',
  //   },
  //   {
  //     key: 'E-Posta',
  //     label: 'E-Posta',
  //     value:
  //       '<div class="params-element" data-key="E-Posta" contenteditable="false">E-Posta Adresi' +
  //       '<span class="remove">' +
  //       '<svg ' +
  //       '    xmlns="http://www.w3.org/2000/svg" ' +
  //       '    width="24" ' +
  //       '    height="24"  ' +
  //       '    viewBox="0 0 24 24" ' +
  //       '    {...props} ' +
  //       '  > ' +
  //       '    <path ' +
  //       '      d="M17.895 5L17.895 16.106 29 16.105 29 17.895 17.895 17.895 17.895 29 16.105 29 16.106 17.895 5 17.895 5 16.105 16.106 16.106 16.105 5z" ' +
  //       '      transform="translate(-5 -5) rotate(45 17 17)" ' +
  //       '    /> ' +
  //       '  </svg>' +
  //       '</span>' +
  //       '</div>',
  //   }
  // ];

  const onChange = (e) => {
    const regex = /(<([^>]+)>)/ig;
    e = e.replace(regex, '');
   //const ASCII_REGEX = /[\x00-\x1F]/;
     // e= e.replace(ASCII_REGEX, "");
    const UNICODE_TURKISH_REGEXP =  /[^\u0000-\u007F|ØøÅåΔΦΓΠΨΣΞÆ£¥èéùìòæßÉ¤ÄÑà¡ñ§¿äışğüçöİŞĞÜÇÖ€\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3]/g
    if (e.match(UNICODE_TURKISH_REGEXP)) {
      Modal.error({
        title: 'Hata',
        content: 'Mesaj metninizde gönderimi desteklenmeyen karakterler "?" ile güncellenmiştir. Lütfen gönderim yapmadan önce mesaj metninizi düzenleyiniz.',
      });
    }
    e=  e.replace(UNICODE_TURKISH_REGEXP,"?");
    setEditableContentHtml(e);
    let degisken = e;
    let degisken2 = e;
    

    props.headers.map((item, index) => {
      const regex = new RegExp(
        '<div class="params-element" data-key="' + item +'" contenteditable="false">(.*?| )*?</div>',
        'mg'
      );
      degisken = degisken.replace(regex, '%' + item + '%');
      degisken2 = degisken2.replace(regex,'');
    });
   
    degisken = degisken.replaceAll('&nbsp;', ' ');
   
    degisken2 = degisken2.replaceAll('&nbsp;', ' ');
   
    props.onChange(degisken.trim());
    setCleanedText(degisken2.trim());
  };


  const SelectParams = (
    <div className="select-message-params__dropdown">
      <ul>
        {props.headers.map((item, index) => (
          <li key={index} onClick={() => onChange('&nbsp;'+editableContentHtml+formatter(paramConst,item)+ '&nbsp;')}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <>
      <Dropdown
        className="menu-dropdown"
        disabled={props.disabled}
        overlay={SelectParams}
        trigger={['click']}
        placement="bottomCenter"
      >
        <div className="select-message-params">
          <div>
            <PlusIcon />
            <span>Mesaja Parametre Ekle</span>
          </div>
          <DownChevronIcon />
        </div>
      </Dropdown>
      <ContentEditable
        className="editable" 
        tagName="div"
        disabled={props.disabled}
        aria-placeholder="Mesajınızı yazın"
        html={editableContentHtml}
        onChange={(e) => onChange(e.target.value)}
        onClick={onClickContentEditable}
        innerRef={editableRef}
      />
     
    </>
  );
};

export default EditableTextarea;
